import * as React from "react";

export const RoundCheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.3625 8.2673V9.03396C17.3614 10.831 16.7796 12.5795 15.7036 14.0188C14.6276 15.4581 13.1152 16.511 11.3919 17.0205C9.66866 17.5301 7.82685 17.4689 6.14119 16.8461C4.45554 16.2234 3.01635 15.0724 2.03827 13.5649C1.06019 12.0573 0.595627 10.274 0.713865 8.48089C0.832103 6.68777 1.52681 4.9809 2.69437 3.61486C3.86193 2.24881 5.43979 1.29678 7.19263 0.900753C8.94546 0.504723 10.7794 0.685912 12.4208 1.4173M17.3625 2.36253L9.02913 10.7042L6.52913 8.20419"
      stroke="#02C473"
      strokeWidth={1.39167}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
